<script lang="ts" setup>
import TagsSelector from '~/components/inputs/TagsSelector.vue'
const model = defineModel<string[]>('modelValue', { required: true })
const showNotTaggedFilter = defineModel<boolean>('noTagsModelValue', {
  required: true,
})
const valueSearched = ref<string | undefined>(undefined)
</script>

<template>
  <TagsSelector
    v-model="model"
    v-model:no-tags-model-value="showNotTaggedFilter"
    :clearable="false"
    :hide-values="true"
    :show-no-tags-option="true"
    placeholder=""
    :allow-create="false"
    no-match-text="No tags found"
    @value-searched="valueSearched = $event"
  >
    <template #prefix>
      <el-icon class="-ml-1"><i-mdi:tag /></el-icon>
      <!-- This is basically a pseudo placeholder text. We don't use the actual
       placeholder because that would hide the placeholder when a value was selected,
       which looks weird with the :hide-values="true" -->
      <span v-if="!valueSearched">Tags</span>
    </template>
  </TagsSelector>
</template>
